import { Header } from '@/components/elements/header/Header'
import { GeoContext } from '@/context/geoContext'
import Head from 'next/head'
import router from 'next/router'
import { useContext, useEffect, useMemo } from 'react'
import { theme } from 'styles/theme'
import { FAQSPageRecord } from 'types'

type FAQSLandingPageProps = {
  faqs: FAQSPageRecord[]
}

export const FAQSLandingPage = ({ faqs }: FAQSLandingPageProps) => {
  const { country } = useContext(GeoContext)
  const faqsForCountry = useMemo(() => {
    if (country) {
      const countryFAQS = faqs.find((faq) => faq.country === country.toUpperCase())

      if (countryFAQS) {
        return countryFAQS
      }

      return faqs.find((faq) => faq.country === 'US')
    }
  }, [country, faqs])

  useEffect(() => {
    if (faqsForCountry) {
      router.push({ pathname: `/faqs/${faqsForCountry.pageSlug}` })
    }
  }, [faqsForCountry])

  return (
    <>
      <Head>
        <title>ZOE FAQ</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <link rel="canonical" href={`${process.env.SITE_URL}/faqs`} />
      </Head>

      <Header backgroundColor={theme.v2.surface.white} />
    </>
  )
}
